import { motion } from "framer-motion";
import { Upload, Wand2, Monitor } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
};

export const HowItWorksSection = () => {
  const steps = [
    { 
      number: "1", 
      title: "Configurez vos salles", 
      description: "Importez ou créez la disposition de vos salles de classe. Avec la formule Premium, on s'en charge pour vous.", 
      icon: Upload 
    },
    { 
      number: "2", 
      title: "Placement intelligent", 
      description: "L'algorithme place automatiquement les élèves selon leurs besoins spécifiques (vue, audition, TSA...).", 
      icon: Wand2 
    },
    { 
      number: "3", 
      title: "Projetez et gagnez du temps", 
      description: "Affichez le plan sur le vidéoprojecteur. Les élèves s'installent en 30 secondes au lieu de 10 minutes.", 
      icon: Monitor 
    },
  ];

  return (
    <section className="py-24 bg-[#F9F9FA] hex-pattern" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#29282B] mb-4">
            Comment ça marche ?
          </h2>
          <p className="text-[#29282B]/60 text-lg">
            3 étapes pour récupérer <strong className="text-[#E7A541]">2h42 de cours par semaine</strong>
          </p>
        </motion.div>

        <div className="relative">
          {/* Connector Line - Desktop */}
          <div className="hidden md:block absolute top-24 left-[16%] right-[16%] h-0.5 bg-[#E7A541]" />

          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer} className="grid md:grid-cols-3 gap-12">
            {steps.map((step, index) => (
              <motion.div key={index} variants={fadeUp} className="text-center relative" data-testid={`step-${index}`}>
                {/* Step Number */}
                <div className="relative z-10 w-12 h-12 rounded-full bg-[#E7A541] text-white font-display font-bold text-xl flex items-center justify-center mx-auto mb-8">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-20 h-20 rounded-2xl bg-white shadow-lg flex items-center justify-center mx-auto mb-6">
                  <step.icon className="text-[#E7A541]" size={36} />
                </div>

                <h3 className="font-display text-xl font-semibold text-[#29282B] mb-3">
                  {step.title}
                </h3>
                <p className="text-[#29282B]/70 max-w-xs mx-auto">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Result highlight */}
        <motion.div 
          initial="hidden" 
          whileInView="visible" 
          viewport={{ once: true }} 
          variants={fadeUp}
          className="mt-16 text-center"
        >
          <div className="inline-flex items-center gap-4 px-8 py-4 bg-[#E7A541] rounded-full text-white">
            <span className="text-lg">Résultat :</span>
            <span className="font-display text-2xl font-bold">+7,3 min par cours = 2h42/semaine/classe</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
